import { render, staticRenderFns } from "./OptimizationControls.vue?vue&type=template&id=496d165e&scoped=true&"
import script from "./OptimizationControls.vue?vue&type=script&lang=js&"
export * from "./OptimizationControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496d165e",
  null
  
)

export default component.exports